import { Action, createReducer, on } from '@ngrx/store';
import {
  termIsCreatedAction,
  removeRecentTermAction
} from 'src/app/actions/term';
import { ITermData } from 'src/app/shared/types/term';

export interface TermState {
  terms: ITermData[];
  recentTerm?: ITermData | null;
}

export const initialState: TermState = {
  terms: [],
  recentTerm: null
};

const _termReducer = createReducer(
  initialState,
  on(termIsCreatedAction, (state, { newTerm }) => ({
    ...state,
    terms: [...state.terms, newTerm],
    recentTerm: newTerm
  })),
  on(removeRecentTermAction, state => ({
    ...state,
    recentTerm: null
  }))
);

export function termReducer(state: TermState | undefined, action: Action) {
  return _termReducer(state, action);
}
